import React from "react";
import Header from "../../Components/Header";

import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import { OMSSERVICES } from "../../Configuration/Telecaller_URl";
import OMSHome from "../../Components/OMS/OMSHome";

function HOME() {
  const storeToken = localStorage.getItem("ssoToken");
  if (storeToken == null) {
    window.location.replace("/");
  }

  return (
    <>
      <Header portal={"TELECALLER"} />
      <SingleSignOnSideBar />
      <main id="main-content">
        <div className="omspage">
          <div className="card-box">
            <OMSHome URL={OMSSERVICES.PENDIG_DATA} mainType={"Retail"} />
          </div>
        </div>
      </main>
    </>
  );
}

export default HOME;
